(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-cards"] && !Shopify.designMode) return;
  try {
    
  const benefitsSection = document.querySelector('[data-benefits-section]');
  if (!benefitsSection) return;

  const cards = benefitsSection.querySelectorAll('[data-benefits-card]');
  const triggers = benefitsSection.querySelectorAll('[data-benefits-trigger]');
  const grid = benefitsSection.querySelector('[data-benefits-grid]');
  const prevBtns = benefitsSection.querySelectorAll('[data-benefits-prev]');
  const nextBtns = benefitsSection.querySelectorAll('[data-benefits-next]');

  let mobileModal = document.querySelector('[data-benefits-mobile-modal]');
  if (!mobileModal) {
    mobileModal = document.createElement('div');
    mobileModal.className = 'benefits-mobile-modal';
    mobileModal.setAttribute('data-benefits-mobile-modal', '');
    mobileModal.innerHTML = `
      <div class="benefits-mobile-modal__overlay" data-benefits-mobile-close></div>
      <div class="benefits-mobile-modal__dialog">
        <div class="benefits-mobile-modal__container" data-benefits-mobile-container></div>
      </div>
    `;
    document.body.appendChild(mobileModal);
  }

  const mobileContainer = mobileModal.querySelector('[data-benefits-mobile-container]');

  const clearFocus = () => {
    cards.forEach((card) => card.classList.remove('benefits-card--focused'));
  };

  const isFocused = (card) => card.classList.contains('benefits-card--focused');

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const closeMobileModal = () => {
    if (!mobileModal || !mobileContainer) return;
    mobileModal.classList.remove('is-open');
    mobileContainer.innerHTML = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  const openMobileModal = (id) => {
    if (!mobileModal) {
      console.error('Mobile modal element not found');
      return;
    }
    if (!mobileContainer) {
      console.error('Mobile container not found');
      return;
    }
    
    const template = document.getElementById(`benefits-mobile-template-${id}`);
    if (!template) {
      console.error('Template not found for id:', id);
      return;
    }
    
    mobileContainer.innerHTML = template.innerHTML;
    mobileModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    setTimeout(() => {
      const closeBtn = mobileContainer.querySelector('[data-benefits-mobile-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeMobileModal);
      }

      const overlay = mobileModal.querySelector('.benefits-mobile-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', closeMobileModal);
      }
    }, 10);
  };

  const focusCard = (id) => {
    cards.forEach((card) => {
      const cardId = card.getAttribute('data-modal-id');
      if (cardId === id) {
        clearFocus();
        card.classList.add('benefits-card--focused');
      }
    });
  };

  const toggleCard = (id) => {
    const target = Array.from(cards).find((card) => card.getAttribute('data-modal-id') === id);
    if (!target) return;

    if (isMobile()) {
      return;
    }

    if (isFocused(target)) {
      clearFocus();
    } else {
      focusCard(id);
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const id = event.currentTarget.getAttribute('data-benefits-trigger');
      if (!id) return;
      event.stopPropagation();
      toggleCard(id);
    });
  });

  cards.forEach((card) => {
    card.addEventListener('click', (event) => {
      if (isMobile()) {
        return;
      }

      const interactive = event.target.closest('a, button');
      if (interactive) return;
      const id = card.getAttribute('data-modal-id');
      if (!id) return;
      toggleCard(id);
    });
  });

  mobileModal?.querySelector('[data-benefits-mobile-close]')?.addEventListener('click', closeMobileModal);

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      closeMobileModal();
    }
  });

  let currentIndex = 0;
  const totalCards = cards.length;

  const scrollToCard = (index) => {
    if (!grid || !cards[index]) return;
    const card = cards[index];
    const cardWidth = card.offsetWidth;
    const gap = isMobile() ? 24 : 21.58;
    const scrollLeft = (cardWidth + gap) * index;
    
    grid.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    
    currentIndex = index;
  };

  const updateCurrentIndex = () => {
    if (!grid) return;
    const scrollLeft = grid.scrollLeft;
    const cardWidth = cards[0]?.offsetWidth || 0;
    const gap = isMobile() ? 24 : 21.58;
    const newIndex = Math.round(scrollLeft / (cardWidth + gap));
    if (newIndex >= 0 && newIndex < totalCards) {
      currentIndex = newIndex;
    }
  };

  if (grid) {
    grid.addEventListener('scroll', updateCurrentIndex);
  }

  prevBtns.forEach((prevBtn) => {
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex = currentIndex - 1;
      } else {
        currentIndex = totalCards - 1;
      }
      scrollToCard(currentIndex);
    });
  });

  nextBtns.forEach((nextBtn) => {
    nextBtn.addEventListener('click', () => {
      if (currentIndex < totalCards - 1) {
        currentIndex = currentIndex + 1;
      } else {
        currentIndex = 0;
      }
      scrollToCard(currentIndex);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('[data-blog-section]');
    if (!section) return;

    const grid = section.querySelector('[data-blog-grid]');
    const prevBtns = section.querySelectorAll('[data-blog-prev]');
    const nextBtns = section.querySelectorAll('[data-blog-next]');
    const cards = section.querySelectorAll('[data-blog-card]');

    if (!grid || cards.length === 0) return;

    function getCardsPerView() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 1440) return 2;
      return 4;
    }

    let cardsPerView = getCardsPerView();

    function updateButtons() {
      if (!grid) return;
      
      const scrollLeft = grid.scrollLeft;
      const scrollWidth = grid.scrollWidth;
      const clientWidth = grid.clientWidth;
      const isAtStart = scrollLeft <= 5;
      const isAtEnd = scrollLeft >= scrollWidth - clientWidth - 5;

      prevBtns.forEach(btn => {
        if (isAtStart) {
          btn.disabled = true;
          btn.style.opacity = '0.3';
          btn.style.pointerEvents = 'none';
        } else {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        }
      });

      nextBtns.forEach(btn => {
        if (isAtEnd) {
          btn.disabled = true;
          btn.style.opacity = '0.3';
          btn.style.pointerEvents = 'none';
        } else {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        }
      });
    }

    function scrollCarousel(direction) {
      if (cards.length === 0 || !grid) return;
      
      const firstCard = cards[0];
      const cardWidth = firstCard.offsetWidth || firstCard.getBoundingClientRect().width || 300;
      const gap = 24;
      const scrollAmount = (cardWidth + gap) * cardsPerView;
      
      const currentScroll = grid.scrollLeft;
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      
      if (direction === 'next') {
        const newScroll = Math.min(currentScroll + scrollAmount, maxScroll);
        grid.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
      } else {
        const newScroll = Math.max(currentScroll - scrollAmount, 0);
        grid.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
      }
      
      setTimeout(updateButtons, 500);
    }
    
    // Garantir que todos os cards sejam renderizados e visíveis
    setTimeout(() => {
      if (grid && cards.length > 0) {
        grid.style.width = '100%';
        grid.style.overflowX = 'auto';
        updateButtons();
      }
    }, 100);

    function handlePrev(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollCarousel('prev');
    }

    function handleNext(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollCarousel('next');
    }

    prevBtns.forEach(btn => {
      btn.addEventListener('click', handlePrev);
    });

    nextBtns.forEach(btn => {
      btn.addEventListener('click', handleNext);
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    
    setTimeout(() => {
      cardsPerView = getCardsPerView();
      updateButtons();
    }, 300);

    window.addEventListener('resize', () => {
      cardsPerView = getCardsPerView();
      setTimeout(updateButtons, 200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
